// extracted by mini-css-extract-plugin
module.exports = {"paper":"style_paper__2DNRr","closeButton":"style_closeButton__2SAHp"};